import { render, staticRenderFns } from "./mattersDetail.vue?vue&type=template&id=f52fc72a&scoped=true"
import script from "./mattersDetail.vue?vue&type=script&lang=js"
export * from "./mattersDetail.vue?vue&type=script&lang=js"
import style0 from "./mattersDetail.vue?vue&type=style&index=0&id=f52fc72a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52fc72a",
  null
  
)

export default component.exports